import {
    isSonoraPluginFileSuggestionsEnabled,
    isSonoraMentionsPluginFileSuggestionsEnabled,
} from '../file/isSonoraPluginFileSuggestionsEnabled';
import {
    isSonoraPluginMeetingTimeSuggestionsEnabled,
    isSonoraMentionsPluginMeetingTimeSuggestionsEnabled,
} from '../meetingTimes/isSonoraPluginMeetingTimeSuggestionsEnabled';
import isSonoraPluginStickyNoteSuggestionsEnabled from '../stickyNotes/isSonoraPluginStickyNoteSuggestionsEnabled';
import { SonoraEntityType, SonoraHintViewState } from 'owa-editor-sonora-types';

const createSonoraHintViewState = () => {
    const availableTypes: SonoraEntityType[] = [];
    let selectedType: SonoraEntityType | undefined;

    if (isSonoraPluginFileSuggestionsEnabled() || isSonoraMentionsPluginFileSuggestionsEnabled()) {
        availableTypes.push(SonoraEntityType.File);
    }

    if (isSonoraPluginStickyNoteSuggestionsEnabled()) {
        availableTypes.push(SonoraEntityType.StickyNotes);
    }

    if (
        isSonoraPluginMeetingTimeSuggestionsEnabled() ||
        isSonoraMentionsPluginMeetingTimeSuggestionsEnabled()
    ) {
        availableTypes.push(SonoraEntityType.MeetingTimes);
    }

    if (availableTypes.length) {
        selectedType = availableTypes[Math.floor(Math.random() * availableTypes.length)];
    }

    const viewState = <SonoraHintViewState>{
        selectedType: selectedType,
        intentDetectionHintShown: new Set<SonoraEntityType>(),
        shouldShowTeachingBubble: false,
        teachingBubbleTarget: { x: 0, y: 0 },
        teachingBubbleText: '',
    };

    return viewState;
};

export default createSonoraHintViewState;
